export default __webpack_public_path__ + "static/media/060.40043e8a.svg";